import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { History } from "history";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import img_banner from "@/img/banner.png";

type Props = {
    children: React.ReactNode;
    history: History;
    onSave?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onBack?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    title: React.ReactNode;
};

class EntityEditTemplate extends React.Component<Props> {
    render() {
        return (
            <div key="ds_new">
                <section key="1">
                    <img src={img_banner} alt="banner" className="img-fluid-header banner_img" />
                </section>
                <section id="profile_edit" className="new_line" key="2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="white_box">
                                    <h2 className="mb-4">{this.props.title}</h2>
                                    {this.props.children}
                                    <div className="button-list button-list-entity-edit order-last ml-auto">
                                        {this.props.onSave && (
                                            <button className="btn btn-primary" onClick={this.props.onSave}>
                                                {translate("common.save", "Save")}
                                            </button>
                                        )}
                                        {this.props.onBack && (
                                            <button className="btn btn-outline-secondary" onClick={this.props.onBack}>
                                                {translate("common.back", "Back")}
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="space30"></div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default withRouter(EntityEditTemplate as React.ComponentType<Props & RouteComponentProps>);
